import Swiper, { Navigation, FreeMode } from "swiper";

export default class MSlider {

  constructor (el) {
    this.el = el
    this.slider = null
    this.next = this.el.querySelector('.m-slider__btn--next')
    this.prev = this.el.querySelector('.m-slider__btn--prev')
    this.isMobile = false;

    this.updateHandler = () => this.updateSlider()
  }

  init () {
    if (window.innerWidth > 1024) {
      this.initSliderDesktop()
      this.isMobile = false
    } else {
      this.initSliderMobile()
      this.isMobile = true
    }

    this.initEvents()
  }

  initEvents () {
    window.addEventListener('resize', this.updateHandler)
  }

  removeEvents () {
    window.removeEventListener('resize', this.updateHandler)
  }

  updateSlider () {
    if (window.innerWidth > 1024) {
      if (!this.isMobile) return;
      this.isMobile = false
      this.destroySlider()
      this.initSliderDesktop()
    } else {
      if (this.isMobile) return;
      this.isMobile = true
      this.destroySlider()
      this.initSliderMobile()
    }
  }

  initSliderDesktop () {
    if (this.slider) return;
    this.slider = new Swiper(this.el, {
      modules: [ Navigation, FreeMode ],
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchSlidesProgress: true,
      watchOverflow: true,
      observer: true,
      preventClicks: false,
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      breakpoints: {
        1025: {
          spaceBetween: 20
        },
        1601: {
          spaceBetween: 30
        }
      }
    })
  }

  initSliderMobile () {
    if (this.slider) return;
    this.slider = new Swiper(this.el, {
      modules: [ Navigation, FreeMode ],
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchSlidesProgress: true,
      watchOverflow: true,
      observer: true,
      freeMode: {
        enabled: true
      },
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      breakpoints: {
        1025: {
          spaceBetween: 20
        },
        1601: {
          spaceBetween: 30
        }
      }
    })
  }

  destroySlider () {
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }
  }

  destroy () {
    this.destroySlider()
    this.removeEvents()
  }

}